import { useTranslation } from 'react-i18next';
import { InfoBlock } from 'components/Shared/InfoBlock';
import * as Styled from './styles';
import { CartTile } from '../CartTile';
import { useAppSelector } from 'appRedux/hooks';

export const CartBody = () => {
  const { t } = useTranslation();
  const {
    data,
    info: { items_count },
    loading
  } = useAppSelector(({ cart }) => cart);

  if (!items_count) {
    return (
      <Styled.CartBody $centered>
        <InfoBlock title={t('cart.cartEmpty')} type="plain" imageType="empty" />
      </Styled.CartBody>
    );
  }

  return (
    <Styled.CartBody>
      {data.map(item => (
        <CartTile key={item.id} cartItem={item} disabled={loading} />
      ))}
    </Styled.CartBody>
  );
};
